import { CONNECTION_TYPES_ENUM } from "../../../constants/autoImportConnectionTypes";
import { AutoImportFormData } from "../../Context/AutoImportFormContext";

// util functions that check if all required inputs are filled
export const validateGeneralInfo = (data: AutoImportFormData): boolean => {
  return Boolean(
    data.jobName?.trim() &&
      data.client &&
      data.forDtc?.trim() &&
      data.associatedInst?.trim() &&
      data.productType
  );
};

export const validateSourceFile = (data: AutoImportFormData): boolean => {
  // must pick one - either ftp or blob
  if (data.sourceFileType === CONNECTION_TYPES_ENUM.FTP) {
    return Boolean(
      data.expectedFileName?.trim() &&
      data.ftpServer?.trim() &&
      data.ftpPort != null &&
      data.ftpUsername?.trim() &&
      data.ftpPassword?.trim()
    );
  }

  if (data.sourceFileType === CONNECTION_TYPES_ENUM.BLOB) {
    return Boolean(
      data.expectedFileName?.trim() &&
      data.blobStorageUsername?.trim() &&
      data.blobStoragePassword?.trim() &&
      data.blobStorageFolder?.trim()
    );
  }
  //returns false if they dont have a storage type selected
  return false;
};
export const validateForm = (data: AutoImportFormData): boolean => {
  return validateGeneralInfo(data) && validateSourceFile(data);
};
